import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnDestroy, ViewChild } from '@angular/core';

// AmCharts
// import * as am4core from "@amcharts/amcharts4/core";
import * as am5map from "@amcharts/amcharts5/map";
// import am4geodata_worldLow from "@amcharts/amcharts4-geodata/worldLow";
// import worldSuperlow from "src/assets/data/worldSuperlow";
// import worldHyperlow from "src/assets/data/worldHyperlow";

//Medium
import { FeatureCollection } from '@amcharts/amcharts4-geodata/.internal/Geodata';
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

import * as am5 from "@amcharts/amcharts5";

// Models
import { CountryViewModel } from 'src/app/_core/models/home/country.model';
import { UserProfileViewModel } from 'src/app/_core/models/main/user-profile.model';
import { UserProfileStore } from 'src/app/_core/stores/user-profile.store';

import am5geodata_worldLow_es from "../../../../../../assets/data/worldLow_ES";

import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-globe-map',
    templateUrl: './globe-map.component.html',
    styleUrls: ['./globe-map.component.scss']
})
export class GlobeMapComponent implements AfterViewInit, OnDestroy, OnChanges {

    @Input() darkMode: boolean = false;

    constructor(private readonly _userProfileStore: UserProfileStore,
        private readonly _translateService: TranslateService) {
        this.userProfile = this._userProfileStore.getUserProfile();
    }

    @ViewChild('divGlobe') divGlobe: ElementRef;

    // Properties
    userProfile: UserProfileViewModel;
    positionCurrentGlobe: number;
    chart: any;
    animation: any;

    @Input() countries: CountryViewModel[];

    // Events
    ngAfterViewInit(): void {
        if (this.darkMode) {
            this._loadMap();
        }
    }

    ngOnDestroy(): void {
        // am4core.disposeAllCharts();
    }

    ngOnChanges(): void {
        if (this.darkMode) {
            this._loadMap();
        }
    }

    // Public methods
    pause() {
        if (this.animation) {
            this.animation.pause();
        }
    }

    start() {
        if (this.animation) {
            this.animation = this.chart.animate({
                key: "rotationX",
                from: this.chart._settings.rotationX,
                to: this.chart._settings.rotationX + 360,
                duration: 60000,
                loops: Infinity,
                stateAnimationDuration: 60000,
                easing: am5.ease.linear
            });
        }
    }

    // Private methods
    _loadMap() {
        // Create root element
        // https://www.amcharts.com/docs/v5/getting-started/#Root_element
        let root = null;
        try {
            root = am5.Root.new("mapdiv");
        } catch(error) {
            return "";
        }

        this.chart = root.container.children.push(am5map.MapChart.new(root, {
            panX: "rotateX",
            panY: "rotateY",
            wheelY: "none",
            projection: am5map.geoOrthographic(),
            paddingBottom: 20,
            paddingTop: 20,
            paddingLeft: 20,
            paddingRight: 20,
            pinchZoom: false,
            rotationY: -25
        }));

        // Set themes
        // https://www.amcharts.com/docs/v5/concepts/themes/
        root.setThemes([
            am5themes_Animated.new(root)
        ]);

        // Create main polygon series for countries
        // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/
        const polygonSeries = this.chart.series.push(am5map.MapPolygonSeries.new(root, {
            geoJSON: am5geodata_worldLow_es
        }));

        polygonSeries.mapPolygons.template.setAll({
            tooltipText: "{name}",
            toggleKey: "active",
            interactive: true,
            fill: am5.color(0xFF4D4D),
            stroke: am5.color("#444444"),
        });

        polygonSeries.mapPolygons.template.states.create("hover", {
            fill: am5.color(0xb71c1c)
        });

        // Countries
        const data_: FeatureCollection = {
            type: "FeatureCollection",
            features: []
        };
        this.countries.forEach(item_country => {
            am5geodata_worldLow_es.features.forEach(item_am5geodata => {
                if (item_country.code.toUpperCase() == item_am5geodata.id.toUpperCase()) {
                    item_am5geodata.properties["name"] = item_country.name /*+ (item_country.zones.length == 1
      ? " (" + item_country.zones?.length + " " + this._translateService.instant("sectors.map.region") + ")" 
            : " (" + item_country.zones?.length + " " + this._translateService.instant("sectors.map.regions") + ")" )*/
                    data_.features.push(item_am5geodata);
                }
            });
        });

        const polygonSeriesUS = this.chart.series.push(am5map.MapPolygonSeries.new(root, {
            geoJSON: data_
        }));

        polygonSeriesUS.mapPolygons.template.setAll({
            tooltipText: "{name}",
            toggleKey: "active",
            interactive: true
        });

        polygonSeriesUS.mapPolygons.template.set("fill", am5.color(0xb71c1c));

        polygonSeriesUS.mapPolygons.template.states.create("hover", {
            fill: am5.color(0xb71c1c)
        });

        polygonSeriesUS.mapPolygons.template.states.create("active", {
            fill: am5.color(0xb71c1c)
        });

        // Create series for background fill
        // https://www.amcharts.com/docs/v5/charts/map-chart/map-polygon-series/#Background_polygon
        const backgroundSeries = this.chart.series.unshift(am5map.MapPolygonSeries.new(root, {}));
        backgroundSeries.mapPolygons.template.setAll({
            fill: am5.color("#444444"),
            strokeOpacity: 0.2
        });
        backgroundSeries.data.push({
            geometry: am5map.getGeoRectangle(90, 180, -90, -180)
        });

        this.animation = this.chart.animate({
            key: "rotationX",
            from: 0,
            to: 360,
            duration: 90000,
            loops: Infinity,
            stateAnimationDuration: 60000,
            easing: am5.ease.linear
        });

        const graticuleSeries = this.chart.series.push(
            am5map.GraticuleSeries.new(root, {})
        );

        graticuleSeries.mapLines.template.setAll({
            stroke: am5.color(0xffffff),
            strokeOpacity: 0.08
        });

        // Make stuff animate on load
        this.chart.appear(1000, 100);

        return () => root.dispose();
    }
}
